export default __webpack_public_path__ + "static/media/house.3ee378c7.png";